"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _Logo = _interopRequireDefault(require("./Logo"));

var _Link = _interopRequireDefault(require("../../components/Link"));

var _Icon = _interopRequireDefault(require("../../components/Icon"));

var _Button = _interopRequireDefault(require("../../components/Button"));

var _HamburgerButton = _interopRequireDefault(require("./HamburgerButton"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var MobileListInner = (0, _styled["default"])('div')(function (_ref) {
  var isOpen = _ref.isOpen,
      theme = _ref.theme;
  return {
    background: 'white',
    position: 'absolute',
    top: '60px',
    left: '0px',
    right: '0px',
    bottom: '0px',
    zIndex: 10,
    transform: isOpen ? 'translateX(0)' : 'translateX(100%)',
    transition: 'transform 0.5s cubic-bezier(0.23, 1, 0.32, 1)',
    willChange: 'transform'
  };
});
var MobileLink = (0, _styled["default"])(_Link["default"])(function (_ref2) {
  var theme = _ref2.theme;
  return {
    backgroundColor: 'white',
    width: '100%',
    textTransform: 'uppercase',
    color: theme.colors.primary,
    display: 'table',
    borderBottom: "1px solid ".concat(theme.colors.lightGray),
    height: '61px',
    textDecoration: 'none',
    '&:last-child': {
      borderBottom: '0px solid transparent'
    }
  };
});
var InnerItemSpan = (0, _styled["default"])('span')({
  display: 'table-cell',
  verticalAlign: 'middle',
  paddingLeft: '15px',
  paddingRight: '15px',
  fontSize: '14px',
  textRendering: 'optimizeLegibility',
  WebkitFontSmoothing: 'antialiased',
  MozOsxFontSmoothing: 'grayscale',
  fontWeight: 600
});
var MobileDisconnectContainer = (0, _styled["default"])('div')(function (_ref3) {
  var theme = _ref3.theme;
  return {
    backgroundColor: 'white',
    borderBottom: "1px solid ".concat(theme.colors.lightGray),
    textAlign: 'center',
    padding: '30px'
  };
});
var UserIcon = (0, _styled["default"])(_Icon["default"])({
  label: 'UserIcon',
  marginRight: '10px'
});

var MobileUserLinks = function MobileUserLinks(_ref4) {
  var links = _ref4.links;
  return links.map(function (l, i) {
    return _react["default"].createElement(MobileLink, {
      key: i,
      href: l.url
    }, _react["default"].createElement(InnerItemSpan, null, _react["default"].createElement(UserIcon, {
      name: "user"
    }), l.label));
  });
};

var MobileList = function MobileList(_ref5) {
  var isOpen = _ref5.isOpen,
      menu = _ref5.menu,
      user = _ref5.user;
  return _react["default"].createElement(MobileListInner, {
    isOpen: isOpen
  }, user && user.links && user.links.length > 0 ? _react["default"].createElement(MobileUserLinks, {
    links: user.links
  }) : null, menu.map(function (l, i) {
    return _react["default"].createElement(MobileLink, {
      key: i,
      href: l.url
    }, _react["default"].createElement(InnerItemSpan, null, l.label));
  }), user && user.disconnect && user.disconnect.url ? _react["default"].createElement(MobileDisconnectContainer, null, _react["default"].createElement(_Button["default"], {
    href: user.disconnect.url,
    size: "big"
  }, user.disconnect.label)) : null);
};

var HeaderMobileInner = (0, _styled["default"])('header')(function (_ref6) {
  var theme = _ref6.theme,
      isOpen = _ref6.isOpen;
  return _objectSpread({
    label: 'HeaderMobile',
    position: 'relative',
    backgroundColor: 'white',
    borderBottom: "1px solid ".concat(theme.colors.lightGray)
  }, isOpen ? {} : {
    overflowX: 'hidden'
  }, _defineProperty({}, theme.media.tablet, {
    display: 'none'
  }));
});
var HeaderMobileWrapper = (0, _styled["default"])('div')(function (_ref7) {
  var theme = _ref7.theme;
  return _defineProperty({
    background: theme.colors.white,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingLeft: '15px'
  }, theme.media.tablet, {
    display: 'none'
  });
});

var HeaderMobile =
/*#__PURE__*/
function (_Component) {
  _inherits(HeaderMobile, _Component);

  function HeaderMobile() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, HeaderMobile);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(HeaderMobile)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isOpen: false
    });

    return _this;
  }

  _createClass(HeaderMobile, [{
    key: "onMenuClick",
    value: function onMenuClick(e) {
      e.preventDefault();
      this.props.onMenuClick && this.props.onMenuClick();
      this.setState(function (state) {
        return {
          isOpen: !state.isOpen
        };
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      /**
       * Jeremy's solution to menu overflow.
       * body is not a solution, break on safari
       * use #root because we pretty sure it exists
       */
      // if (document.querySelector('#root'))
      //   document.querySelector('#root').style.overflow = 'hidden';
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          menu = _this$props.menu,
          logo = _this$props.logo;
      var isOpen = this.state.isOpen;
      return _react["default"].createElement(HeaderMobileInner, {
        isOpen: isOpen
      }, _react["default"].createElement(HeaderMobileWrapper, null, _react["default"].createElement(_Logo["default"], logo), menu.length > 0 ? _react["default"].createElement(_HamburgerButton["default"], {
        isOpen: isOpen,
        onClick: this.onMenuClick.bind(this)
      }) : null), _react["default"].createElement(MobileList, _extends({}, this.props, {
        isOpen: isOpen
      })));
    }
  }]);

  return HeaderMobile;
}(_react.Component);

var _default = HeaderMobile;
exports["default"] = _default;